/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowTaskDto
 */
export interface WorkflowTaskDto {
    /**
     * Name of workflow model
     * @type {string}
     * @memberof WorkflowTaskDto
     */
    workflowModelId?: string;
    /**
     * Version of workflow model. There can be several versions for one model, all of them should be supported by system
     * @type {number}
     * @memberof WorkflowTaskDto
     */
    workflowModelVersion?: number;
    /**
     * Task Type for Workflow participants. Set of task types is different for each workflow model
     * @type {string}
     * @memberof WorkflowTaskDto
     */
    taskType?: string;
    /**
     * Localizable name of the item
     * @type {string}
     * @memberof WorkflowTaskDto
     */
    symbolicTextId?: string;
}

/**
 * Check if a given object implements the WorkflowTaskDto interface.
 */
export function instanceOfWorkflowTaskDto(value: object): boolean {
    return true;
}

export function WorkflowTaskDtoFromJSON(json: any): WorkflowTaskDto {
    return WorkflowTaskDtoFromJSONTyped(json, false);
}

export function WorkflowTaskDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowTaskDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowModelId': json['workflowModelId'] == null ? undefined : json['workflowModelId'],
        'workflowModelVersion': json['workflowModelVersion'] == null ? undefined : json['workflowModelVersion'],
        'taskType': json['taskType'] == null ? undefined : json['taskType'],
        'symbolicTextId': json['symbolicTextId'] == null ? undefined : json['symbolicTextId'],
    };
}

export function WorkflowTaskDtoToJSON(value?: WorkflowTaskDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowModelId': value['workflowModelId'],
        'workflowModelVersion': value['workflowModelVersion'],
        'taskType': value['taskType'],
        'symbolicTextId': value['symbolicTextId'],
    };
}

